import { FC, useState } from 'react';
import { Card, Divider, RadixTable } from '@features/ui';
import {
  periodOptions,
  mockNewAffiliateByUsers,
} from '@features/admin/reports/reportData';
import { TReportNewAffiliateByUsersData, ReportPeriod } from '@src/types';
import { useReportFilters } from '@hooks/useReportFilters';
import { useReportTableColumns } from '@hooks/useReportTableColumns';
import { formatCurrency } from '@lib/utils';

import { ReportFilteringSettings } from '../ReportFilteringSettings';

export const NewAffiliateByUsers: FC = () => {
  const [data] = useState<TReportNewAffiliateByUsersData[]>(
    mockNewAffiliateByUsers
  );

  const filters = useReportFilters({
    defaultPeriod: ReportPeriod.THIS_YEAR,
    enableComparisons: false,
  });

  const { columns, tableData } =
    useReportTableColumns<TReportNewAffiliateByUsersData>({
      data,
      getAccessField: (item) => item.user_name,
      getMainDataField: () => 0,
      customColumns: [
        {
          title: 'Commissions',
          className: 'text-right',
          render: (item) => {
            if (!item) return null;

            return (
              <p className="text-white">{formatCurrency(item.commissions)}</p>
            );
          },
        },
      ],
      includeTotalsRow: true,
    });

  return (
    <div className="flex flex-col gap-5">
      <h1 className="text-2xl font-semibold text-white">
        New Affiliate Commission Amount by User
      </h1>
      <Card>
        <div className="flex lg:flex-row flex-col justify-between items-start mb-5 gap-6">
          <div className="flex gap-6 flex-wrap">
            <ReportFilteringSettings
              dateRangeValue={filters.valueStart}
              isLoading={filters.isLoading}
              periodOptions={periodOptions}
              periodRange={filters.periodRange}
              selectedPeriod={filters.selectedPeriod}
              showGroupByFilter={false}
              onDateRangeChange={filters.setValueStart}
              onPeriodChange={filters.setSelectedPeriod}
              onRunReport={() => console.log('Running report')}
            />
          </div>
        </div>
        <Divider />
        <RadixTable columns={columns} data={tableData} />
      </Card>
    </div>
  );
};
